import React from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { Formik } from "formik";
import * as Yup from "yup";

import LoadingButton from '../../../components/loading_button/LoadingButton';
import { saveEmployeeCalendarEvent, updateEmployeeCalendarEvent, deleteEmployeeCalendarEvent } from '../../../redux/vacations/calendar_employee_events/actions';
import messages from "../../../redux/messages";
import { sumLabHours } from '../utils/date_management';

const schema = Yup.object().shape({
  //employee_code: Yup.string().required("El código de empleado es requerido"),
  title: Yup.string().required("El título es requerido"),
  start_date: Yup.date().required("La fecha de inicio es requerida"),
  end_date: Yup.date().when('type', {
    is: (type) => type === 'Vacaciones',
    then: Yup.date().required("La fecha de fin es requerida").min(
      Yup.ref('start_date'),
      'La fecha de fin debe ser mayor a la fecha de inicio'
    ),
    otherwise: Yup.date().notRequired()
  }),
  location: Yup.string().notRequired("La ubicación de evento"),
  notes: Yup.string().notRequired("Los comentarios adicionales"),
  type: Yup.string().required("El tipo de evento es requerido"),
  hours: Yup.number().when('type', {
    is: (type) => type !== 'Vacaciones',
    then: Yup.number().required("Las horas son requeridas"),
    otherwise: Yup.number().notRequired()
  }),
});

const CalendarAddEvent = ({ isEditForm, setShowModal, showModal, formInitialData, eventTypes, avaibleVac, avaibleCT }) => {
  const dispatch = useDispatch();
  const { isSaveEmployeeCalendarEvent, employeeCalendarSaveEventFail } = useSelector(state => state.calendarEmployeeEvents);

  const onSubmit = (values) => {
    let _req = { ...values, codigo_empleado: formInitialData.employee_code ? formInitialData.employee_code : "" };
    
    if(_req.type !== 'Vacaciones') {
      _req.end_date = sumLabHours(_req.start_date, _req.hours);
    }
    
    if (isEditForm) {
      dispatch(updateEmployeeCalendarEvent(parseInt(formInitialData.id), _req, setShowModal));
    } else {
      dispatch(saveEmployeeCalendarEvent(_req, setShowModal));
    }
    
  }

  const onDelete = () => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteEmployeeCalendarEvent(parseInt(formInitialData.id), setShowModal));
    }
  }

  return (
    <Modal size="lg" show={showModal} onHide={() => setShowModal(false)}>
      <Formik initialValues={
        {
          //employee_code: formInitialData.employee_code ? formInitialData.employee_code : "",
            title: formInitialData.title ? formInitialData.title : "",
            start_date: formInitialData.start ? formInitialData.start : "",
            end_date: formInitialData.end ? formInitialData.end : "",
            hours: formInitialData.hours ? formInitialData.hours : "",
            location: formInitialData.location ? formInitialData.location : "",
            notes: formInitialData.notes ? formInitialData.notes : "",
            type: formInitialData.type ? formInitialData.type : "",
          }
          }
          validationSchema={schema}
          onSubmit={onSubmit}>
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>
              {isEditForm ? 'Actualizar planificación de Vacaciones, Horas Extra y Tiempo Compensatorio' : "Crear Planificación de Vacaciones, Horas Extra y Tiempo Compensatorio"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {employeeCalendarSaveEventFail && (
              <Alert variant="danger" className={"mt-4 mb-1"}>
                {employeeCalendarSaveEventFail}
              </Alert>
              )}
              {
                avaibleVac <= 0 && (
                  <Alert variant="danger" className={"mt-2 mb-1"}><strong>¡No hay vacaciones disponibles para este empleado!</strong></Alert>
                )
              }
              {
                avaibleCT <= 0 && (
                  <Alert variant="danger" className={"mt-2 mb-3"}><strong>¡No hay tiempo compensatorio disponible para programar!</strong></Alert>
                )
              }
              <Form.Group>
                <Form.Label>Título</Form.Label>
                <Form.Control 
                  type="text" 
                  name="title" 
                  placeholder="Ingrese el título del evento"
                  value={values.title} 
                  onChange={handleChange} 
                  onBlur={handleBlur} />
                {errors.title && touched.title && <div className="text-danger">{errors.title}</div>}
              </Form.Group>
              <Form.Group>
                <Form.Label>
                  Tipo
                </Form.Label>
                <Form.Control
                  as="select"
                  id="type"
                  name="type"
                  onBlur={handleBlur}
                  value={values.type}
                  onChange={handleChange}
                >
                  <option
                  className="text-muted"
                  value=""
                  selected
                  disabled
                  >
                  Seleccionar Tipo de Evento
                  </option>

                {
                  (Object.values(eventTypes)).map((eventType) => {
                    if (eventType.isSelected) {
                    return (
                      <option key={eventType.name} value={eventType.name}>{eventType.name}</option>
                    );
                    }
                    return null;
                  })
                }
              </Form.Control>
                {errors.type && touched.type && <div className="text-danger">{errors.type}</div>}
              </Form.Group>
              <Form.Group>
                <Form.Label>Fecha de Inicio</Form.Label>
                <Form.Control type="date" name="start_date" value={values.start_date} onChange={handleChange} onBlur={handleBlur} />
                {errors.start_date && touched.start_date && <div className="text-danger">{errors.start_date}</div>}
              </Form.Group>
              <Form.Group>
                <Form.Label>Fecha Final</Form.Label>
                <Form.Control
                  disabled={values.type !== 'Vacaciones'} 
                  type="date" 
                  name="end_date" 
                  value={values.end_date} 
                  onChange={handleChange} 
                  onBlur={handleBlur} />
                {errors.end_date && touched.end_date && <div className="text-danger">{errors.end_date}</div>}
              </Form.Group>
              {values.type !== 'Vacaciones' && (
                <Form.Group>
                  <Form.Label>Horas</Form.Label>
                  <Form.Control 
                    type="number" 
                    name="hours" 
                    placeholder="Ingrese las horas del evento"
                    value={values.hours} 
                    onChange={handleChange} 
                    onBlur={handleBlur} />
                  {errors.hours && touched.hours && <div className="text-danger">{errors.hours}</div>}
                </Form.Group>
              )}
              <Form.Group>
                <Form.Label>Días y periodo a solicitar</Form.Label>
                <Form.Control 
                  placeholder="Ingrese los días y periodo a solicitar"
                  type="text" 
                  name="location" 
                  value={values.location} 
                  onChange={handleChange} 
                  onBlur={handleBlur} />
                {errors.location && touched.location && <div className="text-danger">{errors.location}</div>}
              </Form.Group>
              <Form.Group>
                <Form.Label>Comentarios</Form.Label>
                <Form.Control 
                  placeholder="Ingrese los comentarios del evento"
                  as="textarea" 
                  rows={3} 
                  name="notes" 
                  value={values.notes} 
                  onChange={handleChange} 
                  onBlur={handleBlur} />
                {errors.notes && touched.notes && <div className="text-danger">{errors.notes}</div>}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              {
                isEditForm && (
                  <Button
                  variant="danger"
                  type="button"
                  onClick={onDelete}
                  >
                  Eliminar
                  </Button>
                )
              }
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Cancelar
              </Button>
              <LoadingButton
                disabled={values.type === 'Vacaciones' ? avaibleVac <= 0 : avaibleCT <= 0} 
                text="Guardar" 
                type="submit" 
                variant="primary" 
                isLoading={isSaveEmployeeCalendarEvent} />
            </Modal.Footer>
            </Form>
          )}
      </Formik>
    </Modal>
  )
}

export default CalendarAddEvent;